import axios, { CancelTokenSource } from 'axios';

import userManager from '../userManager';

const delay = (time: number) => new Promise<void>(res => setTimeout(() => res(), time));

const getUserFunc = async () => {
    const mngr = (await userManager);
    let user = await mngr.getUser();

    while (!user || user.expired) {
        await delay(350);
        user = await mngr.getUser();
    }

    return user;
}

let getUserPromise = getUserFunc();

export async function getWhenAuthorized(urlAction: (personId: number) => string, cancelTokenSource: CancelTokenSource = axios.CancelToken.source(), responseType?: string) {
    const user = await getUserPromise;
    const response = await axios.get(urlAction(user.profile.Id), { cancelToken: cancelTokenSource.token, headers: { 'Authorization': `Bearer ${user.access_token}`, 'Pragma': 'no-cache' }, responseType });

    return response.data;
}

export async function postWhenAuthorized(urlAction: (personId: number) => string, data: any, cancelTokenSource: CancelTokenSource = axios.CancelToken.source()) {
    const user = await getUserPromise;
    const response = await axios.post(urlAction(user.profile.Id), data, { cancelToken: cancelTokenSource.token, headers: { 'Authorization': `Bearer ${user.access_token}` } });

    return response.data;
}

export async function patchWhenAuthorized(urlAction: (personId: number) => string, data: any, cancelTokenSource: CancelTokenSource = axios.CancelToken.source()) {
    const user = await getUserPromise;
    const response = await axios.patch(urlAction(user.profile.Id), data, { cancelToken: cancelTokenSource.token, headers: { 'Authorization': `Bearer ${user.access_token}` } });

    return response.data;
}

export async function deleteWhenAuthorized(urlAction: (personId: number) => string, cancelTokenSource: CancelTokenSource = axios.CancelToken.source()) {
    const user = await getUserPromise;
    const response = await axios.delete(urlAction(user.profile.Id), { cancelToken: cancelTokenSource.token, headers: { 'Authorization': `Bearer ${user.access_token}` } });

    return response;
}

export function updateUserPromise() {
    getUserPromise = getUserFunc();
}